import React from "react";
import "./engineoil.css"; // create a CSS file for styling
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function EngineOilService() {
  return (
    <>
    <Helmet>
      <title>Engine Oil & Filter Change Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Get professional engine oil and filter change service in Palwal. AutoCare provides reliable car repair services with quality oil and filters."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/engine-oil-filter-change"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">
        {/* Left side text */}
        <div className="textContent">
          <h1>Engine Oil & Filter Change Service</h1>

          <p>
            Keeping your engine in top condition starts with regular <strong>Engine Oil & Filter Change</strong>. 
            At <strong>AutoCare</strong>, we provide professional and reliable 
            <span className="highlight"> car repair</span> services, ensuring your vehicle runs smoothly and efficiently.
            Servicing with <span className="highlight">Auto Care in Palwal</span> guarantees quality and peace of mind.
          </p>

          <h2>Why Engine Oil & Filter Change Is Important?</h2>
          <p>
            Engine oil lubricates engine parts, reduces friction, and prevents overheating. 
            Changing the oil and filter regularly prevents engine damage, improves fuel efficiency, 
            and extends the life of your car.
          </p>

          <h2>Our Engine Oil & Filter Service Includes:</h2>
          <ul>
            <li>Complete engine oil drain and replacement</li>
            <li>Oil filter inspection and replacement</li>
            <li>Check for leaks and oil system health</li>
            <li>Top-up other essential fluids if needed</li>
            <li>Engine performance check after service</li>
          </ul>

          <h2>Benefits of Choosing AutoCare</h2>
          <ul>
            <li>Expert technicians and quality oil filters</li>
            <li>Prevents engine wear and costly repairs</li>
            <li>Improves fuel economy and engine efficiency</li>
            <li>Trusted <span className="highlight">car repair service</span> in Palwal</li>
          </ul>

          <h2>Book Engine Oil & Filter Change</h2>
          <p>
            Need a trusted <span className="highlight">car repair</span>? 
            With <strong>AutoCare</strong>, you can easily book your <span className="highlight">Engine Oil & Filter Change</span> 
            online or visit our workshop in Palwal. Your car will be in expert hands.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">  
            Book Engine Oil & Filter Change
            </Link>
          </button>
        </div>

        {/* Right side image */}
        <div className="imageContent">
          <img src="/carServiceImages/engineoil.webp" alt="Engine Oil and Filter Change Service" />
        </div>
      </div>
    </section>
    </>
  );
}
